import check from "../../../assets/icons/check.png";
import error from "../../../assets/icons/error.png";

const labelMapping = {
  doorInManual: {
    null: <p className="null-data">No Mode Data</p>,
    0: <p className="auto">Auto</p>,
    1: <p className="manual">Manual</p>,
  },
  readyForLoading: {
    null: <p className="null-data">No Loading Data</p>,
    0: <p className="not-ready-for-loading">Not Ready for Loading</p>,
    1: <p className="ready-for-loading">Ready for Loading</p>,
  },
};

const DockDoorStatus = ({ loading, dockDoorStatus }) => {
  const getTextCardValue = (label, data) =>
    data !== undefined ? labelMapping[label][data] : null;

  const renderCardStatus = ({
    lgvInTrailer,
    doorOpen,
    trailerAtDoor,
    airbagHold,
    fault,
  }) => (
    <div className="status-card-status-wrapper">
      {[
        { isActive: lgvInTrailer === 1, label: "LGV Inside" },
        { isActive: doorOpen === 1, label: "Door Open" },
        { isActive: trailerAtDoor === 1, label: "Trailer At Door" },
        { isActive: airbagHold === 1, label: "Airbag Hold" },
        { isActive: fault === 1, label: "Fault" },
      ].map(({ isActive, label }) => (
        <div key={label} className="status-card">
          <img src={isActive ? check : error} alt={label} />
          <p>{label}</p>
        </div>
      ))}
    </div>
  );

  return (
    <div className="detail-section-container column-section">
      <div
        className="additional-data-section-title"
        style={{ padding: "20px 30px 0 30px" }}
      >
        <h3 style={{ margin: 0 }}>Status</h3>
        {Object.keys(dockDoorStatus).length && (
          <div className="status-card-text">
            {getTextCardValue("doorInManual", dockDoorStatus.doorInManual)}
          </div>
        )}
        {Object.keys(dockDoorStatus).length && (
          <div className="status-card-text">
            {getTextCardValue(
              "readyForLoading",
              dockDoorStatus.readyForLoading
            )}
          </div>
        )}
      </div>
      {loading ? (
        <div className="dock-spinner-wrapper">
          <h4>Fetching Status...</h4>
          <div className="spinner"></div>
        </div>
      ) : (
        <div className="details-wrapper">
          {Object.keys(dockDoorStatus).length
            ? renderCardStatus(dockDoorStatus)
            : null}
        </div>
      )}
    </div>
  );
};

export default DockDoorStatus;
